export const MOCK_INVOICES = [
  {
    id: "in_1RpqMuReTBWwQAKnvhiGyLzm",
    status: "paid",
    amount_due: 49,
    created: 1753706488,
    paid: "paid",
    url: "https://invoice.stripe.com/i/acct_1RO5moReTBWwQAKn/test_YWNjdF8xUk81bW9SZVRCV3dRQUtuLF9TbE43dGNxbjFVS2U4Y2ZYc1NYR2VyR3pRVzN6MU9YLDE0NTQ1NDQ0Nw02001mf06iaQ?s=ap",
  },
  {
    id: "in_1RlSFAReTBWwQAKnFge3hXmt",
    status: "paid",
    amount_due: 0,
    created: 1752660440,
    paid: "paid",
    url: "https://invoice.stripe.com/i/acct_1RO5moReTBWwQAKn/test_YWNjdF8xUk81bW9SZVRCV3dRQUtuLF9TZ3B2Vzc5Uk82UHZQVGc1dGk4QTM4MkdZOHNMd2kzLDE0NTQ1NDQ0Nw0200PClXXYD5?s=ap",
  },
  {
    id: "in_1RgNttReTBWwQAKn9cJemSqX",
    status: "paid",
    amount_due: 0,
    created: 1751452105,
    paid: "paid",
    url: "https://invoice.stripe.com/i/acct_1RO5moReTBWwQAKn/test_YWNjdF8xUk81bW9SZVRCV3dRQUtuLF9TYmI2b3hCVlFhWG5xUDUxTm9FWmlBcjZWNkhUZnRqLDE0NTQ1NDQ0Nw02004KX9s4FA?s=ap",
  },
];
